import React from 'react';
import {observer} from 'mobx-react';
import {loader, t} from 'shared/core';
import {FormattedMessage} from 'react-intl';
import AssignDocumentButton from './AssignDocumentButton';
import EmployeeDocumentList from './EmployeeDocumentList';
import EditDocumentModal from './EditDocumentModal';
import MoveDocumentModal from './MoveDocumentModal';
import UploadDocumentModal from './UploadDocumentModal';
import AssignDocumentModal from './assign_document/AssignDocumentModal';
import AssignDocumentEditModal from './assign_document/AssignDocumentEditModal';
import {Panel, Button} from 'shared/components';
import EmployeeDocumentState from './state/EmployeeDocumentState';

const EmployeeDocumentButtons = observer(({uiState, parentState}) => {
  return (
    <div className='flex right'>
      {parentState.editDataPermission('::DOCUMENTS') &&
        <div className='table-cell align-middle'>
          <Button size='sm' onClick={() => uiState.openUploadModal()} disabled={uiState.isUploading}>
            <FormattedMessage id='employees.profile.documents.Upload File(s)'/>
          </Button>
        </div>
      }
      <AssignDocumentButton uiState={uiState}/>
    </div>
  );
});

@observer class EmployeeDocumentsContainerWithState extends React.Component {
  render() {
    const {uiState} = this.props;
    const {parentState} = uiState;

    return (
      <Panel>
        <Panel.Header title={t('employees.profile.documents.Documents')}>
          <EmployeeDocumentButtons uiState={uiState} parentState={parentState}/>
        </Panel.Header>
        <EmployeeDocumentList uiState={uiState}/>
        <AssignDocumentModal
          uiState={uiState}
          choosingDocumentAction={uiState.choosingDocumentAction}
          assigningExistingDocument={uiState.assigningExistingDocument}
          choosingDocumentType={uiState.choosingDocumentType}
        />
        <AssignDocumentEditModal uiState={uiState}/>
        <EditDocumentModal uiState={uiState}/>
        <MoveDocumentModal uiState={uiState}/>
        <UploadDocumentModal uiState={uiState} onSave={() => uiState.handleUploadModalSave()}/>
      </Panel>
    );
  }
}

async function load({parentState}) {
  const uiState = new EmployeeDocumentState(parentState);
  await uiState.load();
  return { uiState };
}

export default loader(EmployeeDocumentsContainerWithState, load);
